import { Injectable } from '@angular/core';
import { IProductBootstrapService } from '../../common/services/product-bootstrap.service';
import { TableConfigurationOverrideService } from '../../common/services/table-configuration-override.service';
import { SideBarMenuService } from '../../common/services/side-bar-menu.service';
import { getFinanceMenuItems } from './finance-menu-items';
import { defaultProjectTableColumns } from '../projects/components/project-table-wrapper/project-table-definitions';
import { AdminUiSettings } from '../../common/dtos';

@Injectable({
  providedIn: 'root',
})
export class FinanceBootstrapService implements IProductBootstrapService {
  constructor(
    private readonly tableConfigService: TableConfigurationOverrideService,
    private readonly sideBarMenuService: SideBarMenuService
  ) {
    // Do not initalize anything here. This service will be created regardless of product type.
  }

  initializeForProduct(settings: AdminUiSettings): void {
    this.registerMenuItems(settings);
    this.registerTableOverrides();
  }

  private registerMenuItems(settings: AdminUiSettings) {
    this.sideBarMenuService.registerMenuItems(getFinanceMenuItems(settings));
  }

  private registerTableOverrides() {
    this.tableConfigService.overrideAllColumnsForTable({
      uniqueTableId: 'project-table',
      allColumns: [
        defaultProjectTableColumns.title,
        defaultProjectTableColumns.organisation,
        defaultProjectTableColumns.startDate,
        defaultProjectTableColumns.status,
        defaultProjectTableColumns.actionButton,
      ],
    });
  }
}
